import { useOneTrustConsent, ONE_TRUST_CATEGORIES } from "./useOneTrustConsent";

type UsePerformanceConsentOptions = {
  /**
   * When OneTrust is not configured for a host app, keep the legacy behavior:
   * consent-gated libraries are allowed to load normally. The consent gate is
   * only enforced when the host app provides a OneTrust domain script ID.
   */
  oneTrustEnabled?: boolean;
};

export function usePerformanceConsent({
  oneTrustEnabled = true,
}: UsePerformanceConsentOptions = {}): boolean {
  const { hasConsent } = useOneTrustConsent();
  if (!oneTrustEnabled) return true;

  return hasConsent(ONE_TRUST_CATEGORIES.PERFORMANCE);
}
